
import './scripts/init.js';
import './components.js';
import { _slideToggle } from './scripts/other/animation.js';
import { hideScrollbar, showScrollbar } from './scripts/other/scroll.js';

//
//
//
//
// Общие скрипты


// 
// 
// Слайдеры

// Наши проекты
if (document.querySelector('.project-container')) {
	let projectSlider = new Swiper('.project-container', {
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true
		},
		loop: true,
		pagination: {
			el: '.project__pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
			nextEl: '.project__next',
			prevEl: '.project__prev',
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		speed: 500,
		breakpoints: {
			1: {
				slidesPerView: 1,
				spaceBetween: 12,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 16,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
		},
	});
}

// Новости
if (document.querySelector('.news-container')) {
	let newsSlider = new Swiper('.news-container', {
		autoplay: {
			delay: 4000,
			pauseOnMouseEnter: true
		},
		loop: true,
		pagination: {
			el: '.news__pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
			nextEl: '.news__next',
			prevEl: '.news__prev',
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		speed: 500,
		breakpoints: {
			1: {
				slidesPerView: 1,
				spaceBetween: 12,
			},
			576: {
				slidesPerView: 2,
				spaceBetween: 16,
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
		},
	});
}


// Фильтрация в мобильной версии
let filterButton = document.querySelector('.filter__title-button');
let filterContent = document.querySelector('.filter__content');

if (filterButton) {
	filterButton.addEventListener('click', function () {
		this.classList.toggle('active')
		_slideToggle(filterContent)

		if (this.classList.contains('active')) {
			hideScrollbar();
		} else {
			showScrollbar()
		}
	});
}

// input range
let ranges = document.querySelectorAll('.range');

if (ranges) {
	ranges.forEach((rangeBlock) => {
		const rangeMin = rangeBlock.querySelector('input[type=range][data-role="min"]')
		const rangeMax = rangeBlock.querySelector('input[type=range][data-role="max"]')
		const inputMin = rangeBlock.querySelector('input[type=number][data-role="min"]')
		const inputMax = rangeBlock.querySelector('input[type=number][data-role="max"]')
		const rangeBetween = rangeBlock.querySelector('.range__between')
		const track = rangeBlock.querySelector('.range__track')

		const minValue = parseInt(rangeMin.min)
		const maxValue = parseInt(rangeMax.max)
		let isTouched = false

		function activateBetween() {
			if (!isTouched) {
				rangeBetween.style.display = 'block'
				isTouched = true
			} else {
				if (!rangeBlock.classList.contains('active')) {
					rangeBlock.classList.add('active')
				}
			}
		}

		function updateBetween(min, max) {
			const range = maxValue - minValue
			const left = ((min - minValue) / range) * 100
			const right = 100 - ((max - minValue) / range) * 100
			rangeBetween.style.left = `${left}%`
			rangeBetween.style.right = `${right}%`
		}

		function syncFromRange() {
			activateBetween()

			let min = parseInt(rangeMin.value)
			let max = parseInt(rangeMax.value)
			if (min > max) [min, max] = [max, min]

			inputMin.value = min
			inputMax.value = max

			updateBetween(min, max)
		}

		function syncFromInput() {
			activateBetween()

			let min = parseInt(inputMin.value)
			let max = parseInt(inputMax.value)

			min = Math.max(minValue, Math.min(min, maxValue))
			max = Math.max(minValue, Math.min(max, maxValue))

			if (min > max) [min, max] = [max, min]

			inputMin.value = min
			inputMax.value = max
			rangeMin.value = min
			rangeMax.value = max

			updateBetween(min, max)
		}

		track.addEventListener('click', (e) => {
			if (!(e.target.classList.contains('range__track') || e.target.classList.contains('range__between'))) {
				return;
			}

			const rect = track.getBoundingClientRect();
			const clickX = e.clientX - rect.left;
			const clickRatio = clickX / rect.width; // 0..1
			const clickedValue = Math.round(minValue + clickRatio * (maxValue - minValue));

			const distToMin = Math.abs(clickedValue - parseInt(rangeMin.value));
			const distToMax = Math.abs(clickedValue - parseInt(rangeMax.value));

			if (distToMin <= distToMax) {
				rangeMin.value = clickedValue;
			} else {
				rangeMax.value = clickedValue;
			}
			syncFromRange();
		});

		rangeMin.addEventListener('input', syncFromRange)
		rangeMax.addEventListener('input', syncFromRange)
		inputMin.addEventListener('change', syncFromInput)
		inputMax.addEventListener('change', syncFromInput)

		rangeBlock.closest('form').querySelector('[type="reset"]').addEventListener('click', function () {
			rangeBetween.style.left = "0"
			rangeBetween.style.right = "0"
		});

		syncFromRange()
	})
}


// Секция Кто мы 
const who = document.querySelector('.info .container .who')
const info = document.querySelector('.info')

if (info && who) {
	const container = info.querySelector('.container')
	const parent = info.parentNode

	let movedOut = false

	const ro = new ResizeObserver(entries => {
		for (let entry of entries) {
			const width = entry.contentRect.width

			if (width <= 1199 && !movedOut) {
				parent.insertBefore(who, info)
				movedOut = true
			}
			else if (width > 1200 && movedOut) {
				container.insertBefore(who, container.firstChild)
				movedOut = false
			}
		}
	})
	ro.observe(document.body)
}


// Кнопка Все вопросы в FAQ 
let faqButton = document.querySelector('.faq__button');

if (faqButton) {
	faqButton.addEventListener('click', function () {
		this.closest('.faq').querySelectorAll('.faq__item[hidden]').forEach(item => {
			item.hidden = false

			this.remove()
		});
	});
}

